// Deduplicate by identity, never by name: two depots may share a company name.
export function uniqueDirectoryRecords(records = []) {
  const byId = new Map();
  for (const record of records) {
    const key = record.id || record;
    const existing = byId.get(key);
    byId.set(key, existing ? { ...existing, roles: [...new Set([...(existing.roles || []), ...(record.roles || [])])] } : record);
  }
  return [...byId.values()];
}

export function directorySearchResults(companies, places, activeRole) {
  return [["company", companies], ["place", places]].flatMap(([kind, records]) =>
    uniqueDirectoryRecords(records).map(record => {
      const roles = [...new Set(record.roles || [])];
      return { record, roles, role: roles.includes(activeRole) ? activeRole : roles[0], key: `${kind}:${record.id}` };
    }).filter(result => result.role)
  );
}
